import { SettingsAccountDeleteSection } from '../components/settings/SettingsAccountDeleteSection.js'
import { SettingsContactSection } from '../components/settings/SettingsContactSection.js'
import { SettingsEmailSection } from '../components/settings/SettingsEmailSection.js'
import { SettingsGoogleSection } from '../components/settings/SettingsGoogleSection.js'
import { SettingsNotificationEmailSection } from '../components/settings/SettingsNotificationEmailSection.js'
import { SettingsPasswordSection } from '../components/settings/SettingsPasswordSection.js'
import { SettingsPlanSection } from '../components/settings/SettingsPlanSection.js'
import { SettingsWorkspaceSection } from '../components/settings/SettingsWorkspaceSection.js'
import { useAuth } from '../lib/auth-context.js'
import { FETCH_ERROR_FALLBACK, toUserMessage } from '../lib/error-copy.js'
import { useIdentities } from '../lib/google-link.js'
import { LOADING } from '../lib/labels.js'
import { describeLoginMethods } from '../lib/login-identities.js'
import { useMeTenant } from '../lib/me-api.js'

/**
 * 設定画面。
 *
 * ワークスペース名・プラン・認証情報・通知先メールアドレス・運営問い合わせ・アカウント削除依頼。
 *
 * Google だけでログインしている人には、パスワード変更とログイン用メールアドレス変更を出さない
 * （パスワードを持たず、メールアドレスは Google 側で決まるため。Issue #118）。
 */
export function SettingsPage() {
  const meTenantQ = useMeTenant()
  const { session } = useAuth()
  const identitiesQ = useIdentities({ enabled: session !== null })
  // 取得前はセッションに載っている identities で判断し、欄が後から消えるちらつきを避ける
  const methods = describeLoginMethods(identitiesQ.data ?? session?.user.identities)

  return (
    <div className="max-w-3xl mx-auto px-6 md:px-10 py-10 md:py-16 space-y-8 grain">
      <section>
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-muted-foreground/80 mb-3">
          Settings
        </p>
        <h1 className="font-display text-4xl md:text-5xl font-semibold leading-[1.05] tracking-tight">
          設定
        </h1>
      </section>

      {meTenantQ.isLoading && <p className="text-sm text-muted-foreground">{LOADING.fetching}</p>}
      {meTenantQ.error && (
        <div className="border border-destructive/40 bg-destructive/5 rounded-md p-4 text-sm text-destructive">
          {toUserMessage(meTenantQ.error, FETCH_ERROR_FALLBACK)}
        </div>
      )}

      {meTenantQ.data && (
        <>
          <SettingsPlanSection tenant={meTenantQ.data} />
          <SettingsWorkspaceSection tenant={meTenantQ.data} />
        </>
      )}

      {!methods.isGoogleOnly && <SettingsPasswordSection />}
      {!methods.isGoogleOnly && <SettingsEmailSection />}
      {session && <SettingsGoogleSection methods={methods} />}
      <SettingsNotificationEmailSection />
      <SettingsContactSection />
      <SettingsAccountDeleteSection />
    </div>
  )
}
